import React from 'react';
import EmptyState from '../../EmptyState';
import { classes } from '../Table.st.css.js';
import { defaultEmptyStateProps } from '../../EmptyState/EmptyState';
export const TableEmptyState = ({ theme = defaultEmptyStateProps.theme, image = defaultEmptyStateProps.image, children = defaultEmptyStateProps.children, align = defaultEmptyStateProps.align, ...propsWithNoDefaults }) => {
    const props = { theme, image, children, align, ...propsWithNoDefaults };
    return (React.createElement("div", { className: classes.emptyStateContainer },
        React.createElement(EmptyState, { ...props })));
};
TableEmptyState.displayName = 'Table.EmptyState';
TableEmptyState.propTypes = {
    ...EmptyState.propTypes,
};
//# sourceMappingURL=TableEmptyState.js.map